import _ from 'underscore';
import pillControlTemplate from './template/pill-control.pug';

export function renderPillControl(pillControl) {
  const options = _.defaults({}, pillControl, {
    classes: [],
    id: _.uniqueId('pill-control-'),
    onClick: _.noop,
    selectedIndex: 0,
    items: [],
  });
  // set a default title to each item.
  options.items = options.items.map(item => _.defaults({}, item, {
    title: item.title || item.text || '',
  }));

  const html = pillControlTemplate(options);
  const events = {};

  _.each(options.items, (item, index) => {
    events[`click li a#${index}`] = () => {
      options.onClick(index);
    };
  });
  return { html, events };
}

